import React, { Component } from 'react';

export default class Error extends Component {
	constructor(props){
	    super(props);
	    this.removeText = this.removeText.bind(this);
	}
	removeText(){
		this.props.textAction();
	}

  	render() {
      return (
        <span className="danger-msg" onClick={this.removeText}>
          {this.props.text}
        </span>
      );
    }
}